"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTljCreateRecord = getTljCreateRecord;
exports.getTljUseDetail = getTljUseDetail;
var _request = _interopRequireDefault(require("@/utils/request"));
function getTljCreateRecord(data) {
  return (0, _request.default)({
    url: '/portal/system/tlj/getTljCreateRecord',
    method: 'post',
    data: data
  });
}
// 淘礼金使用详情
function getTljUseDetail(data) {
  return (0, _request.default)({
    url: '/portal/system/tlj/getTljUseDetail',
    method: 'post',
    data: data
  });
}